import { useEffect } from 'react';

import { useStores } from './useStores';

import { createSelectedHook } from '~/core/utils';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import {
  selectRestorableStoreId,
  selectSelectedStore,
  updateSelectedStore,
} from '~/redux/slices/store';

export const useSelectedStore = () => {
  const currentSelectedStore = useAppSelector(selectSelectedStore);
  const { selectedValue: selectedStore } = createSelectedHook({
    selector: selectSelectedStore,
    restorableSelector: selectRestorableStoreId,
    apiQueryHook: useStores,
    selectRestorableValue: ({
      apiHookResponse,
      restorableValue,
      selectedValue,
    }) =>
      selectedValue ||
      apiHookResponse.stores.find(
        (store) => store.companyId === restorableValue
      ),
    shouldReturnDefault: ({ selectedValue, apiHookResponse }) =>
      !selectedValue ||
      !apiHookResponse.stores.find(
        (store) => store.companyId === selectedValue.companyId
      ),
    selectDefaultValue: ({ apiHookResponse }) => apiHookResponse.stores[0],
  })();

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (
      selectedStore &&
      selectedStore.companyId !== currentSelectedStore?.companyId
    ) {
      dispatch(updateSelectedStore(selectedStore));
    }
  }, [selectedStore, dispatch, currentSelectedStore?.companyId]);

  return selectedStore;
};
